import React from 'react';
import { Divider, Card, Icon } from 'antd';
import AlexDWallImage from 'static/img/AlexDWall.jpg';
import styles from './EducationThatWorksForEveryoneBlock.module.scss';
import { useTranslation } from 'react-i18next';

const { Meta } = Card;

export default function EducationThatWorksForEveryoneBlock() {
  const {
    mainContainerStyle,
    centerStyle,
    subHeaderStyle,
    subHeaderParagraphStyle,
    cardImageStyle,
    cardImageHeaderStyle,
    cardImageParagraphStyle
  } = styles;

  const { t } = useTranslation()

  return (
    <>
      <h1>{t('About Us')}</h1>
      <Divider />
      <div className={mainContainerStyle}>
        <div className={centerStyle}>
          <h2 className={subHeaderStyle}>
            {t('Education that works for everyone')}
          </h2>
          <p className={subHeaderParagraphStyle}>
            {t('Tutor House is on a mission to make educational success accessible for all, not matter goals or prior experience')}
          </p>
          <Card
            hoverable
            style={{
              width: 710,
              margin: '5%',
              cursor: 'default'
            }}
            cover={
              <div
                className={cardImageStyle}
                style={{
                  backgroundImage: `url(${AlexDWallImage})`
                }}
              >
                <div>
                  <h2 className={cardImageHeaderStyle}>
                    {t('A note from our Founder')}
                  </h2>
                  <p className={cardImageParagraphStyle}>
                    {t('Read a letter from Alex Dyer, founder and CEO, on the story and mission of Tutor House')}
                  </p>
                </div>
                <div>
                  <Icon
                    style={{ color: 'white', fontSize: '40px' }}
                    type="arrow-down"
                  />
                </div>
              </div>
            }
          >
            <Meta
              description={
                <>
                  <p>
                    {t('In 2013, fuelled by a dissatisfaction with the state of education, I left my job as a Psychology teacher of 8 years and committed myself to building a tutoring platform that would give all students the chance to access a top quality and personalised education I looked at the brilliant students, teachers and parents around me and saw an opportunity to mentor them and to help them grow both academically and personally')}
                  </p>
                  <p>
                    {t('That was five years ago Today, Tutor House is one of the leading tutoring platforms in London, offering expertly tailored tuition both online and in-person to students all across the country We provide private tuition, adult learning, retakes for A-levels and GCSEs, homeschooling and more')}
                  </p>
                  <p>
                    {t('As with learning, we didn’t get everything right first-time We’ve hit a few bumps in the road, but, with the support of our close-knit team of tutors and students, have overcome them and are stronger and more determined than ever before')}
                  </p>
                  <p>
                    {t('Our mission is to make learning available and accessible to students, no matter their age, level or budget We have no doubt that we will achieve this, and we want to take every brilliant teacher, tutor, learner and student on that path with us')}
                  </p>
                  <p>
                    {t('Education is the cornerstone of everything we do, but our tutors and students are the reason we have come so far I can’t promise to be without fault, but I can promise to listen, to evolve and to be honest in everything I do I look forward to sharing your educational journey')}
                  </p>
                  <p>{t('Happy Tutoring')}</p>
                  <p>{t('Alex')}</p>
                </>
              }
            />
          </Card>
        </div>
      </div>
    </>
  );
}
